// extracted by mini-css-extract-plugin
export default {"container":"Jj","blur":"Kj","spinner":"Lj","spin":"Mj"};